import { NavLink, useNavigate } from 'react-router-dom';
import useContextStore, { selectCurrentContext } from '../../store/useContextStore';
import useAuthStore from '../../store/useAuthStore';
import useMyProfileStore, { selectMyMetadata } from '../../store/useMyProfileStore';
import { navForContext, PATHS } from '../../routes/navConfig';
import { initialsOf, shortNameOf } from '../../utils/avatar';
import { IconSignOut } from '../icons';
import Avatar from '../common/Avatar';

export default function Sidebar() {
  const ctx = useContextStore(selectCurrentContext);
  const logout = useAuthStore((s) => s.logout);
  const meta = useMyProfileStore(selectMyMetadata);
  const navigate = useNavigate();
  const name = meta?.name || '';

  const handleLogout = () => {
    useMyProfileStore.getState().reset();
    useContextStore.getState().resetContexts();
    logout();
    navigate(PATHS.LOGIN);
  };

  return (
    <div className="sidebar">
      <div className="brand">
        <div className="mark">R</div>
        <div className="txt">
          Room Parent<small>Portal</small>
        </div>
      </div>
      <div id="sidebarNav">
        {navForContext(ctx).map(({ path, label, Icon }) => (
          <NavLink key={path} to={path} className={({ isActive }) => `nav-item ${isActive ? 'on' : ''}`}>
            <Icon />
            {label}
          </NavLink>
        ))}
      </div>
      <div className="sidebar-foot">
        <div className="who" style={{ cursor: 'pointer' }} onClick={() => navigate(PATHS.PROFILE)}>
          <Avatar
            src={meta?.profilePic}
            initials={initialsOf(name)}
            color="linear-gradient(145deg,#1e3e2b,#4fa472)"
            size={30}
            fontSize={11}
          />
          <span>
            <span className="nm">{shortNameOf(name) || '—'}</span>
            <span className="role">Room Parent</span>
          </span>
        </div>
        <div className="signout" onClick={handleLogout}>
          <IconSignOut />
          Sign Out
        </div>
      </div>
    </div>
  );
}
